import { changeLanguage as changeSlSdkLanguage } from 'sl-sdk';

import localeEn from 'i18n/en.json';
import localeFr from 'i18n/fr.json';
import { getAgentLocale } from 'zaf/client';

export type SupportedLocale = 'en' | 'fr';

const messagesByLocale: Record<SupportedLocale, Record<string, string>> = {
  en: localeEn,
  fr: localeFr,
};

export const DEFAULT_LOCALE: SupportedLocale = 'en';

export function toSupportedLocale(rawLocale: string | null | undefined): SupportedLocale {
  return rawLocale?.toLowerCase().startsWith('fr') ? 'fr' : DEFAULT_LOCALE;
}

export function getMessages(locale: SupportedLocale): Record<string, string> {
  return messagesByLocale[locale];
}

// The Zendesk agent locale wins over the browser one, but ZAF is only available inside Zendesk.
export async function resolveLocale(): Promise<SupportedLocale> {
  const agentLocale = await getAgentLocale();
  const locale = toSupportedLocale(agentLocale ?? navigator.language);
  await changeSlSdkLanguage(locale);
  return locale;
}
